import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useStyles } from "../styles";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";

//assets
import NoBackground from "../../../assets/background/no-img.png";

type LayoutProps = {
  expanded?: boolean;
  onChange?: (isExpanded: boolean) => void;
};

export function Layout({ expanded, onChange }: LayoutProps) {
  const styles = useStyles();

  return (
    <Accordion
      expanded={expanded}
      elevation={0}
      className={styles.rootAccordion}
      onChange={(_, isExpanded) => (onChange ? onChange(isExpanded) : {})}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography>Layout</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Stack spacing={2}>
          <Typography variant="body2" color="GrayText">
            Selecione produtos da lista e a forma que aparecerão na imagem.
          </Typography>
          <Typography variant="body2" className={styles.link}>
            Selecionar produtos
          </Typography>
          <Stack spacing={1} width="20%" alignItems="center">
            <img
              className={styles.imgStore}
              src={NoBackground}
              alt="preview-layout"
            />
            <Button size="small">Selecionar layout</Button>
          </Stack>
          <Stack direction="row" spacing={4}>
            <Button size="small" color="inherit">
              Cancelar
            </Button>
            <Button size="small" variant="contained">
              Salvar
            </Button>
          </Stack>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
